import { API_USER_FAVORITES, API_USER_FAVORITES_ID } from '../constants';

export default class Profile {
	static async favorites() {
		if (wpProfile && !(wpProfile.auth)) { return; }
		this.favorites = await $.ajax({ url: API_USER_FAVORITES });
		document.querySelectorAll('[data-save-favorite]').forEach(item => {
			const { id } = item.dataset;
			if (this.favorites.includes(id)) {
				item.classList.toggle('is-saved');
			}

			// Toggle favorite on click
			item.addEventListener('click', async event => {
				event.preventDefault();
				let method = 'DELETE';
				let url = API_USER_FAVORITES_ID;
				let data = {};
				if (!this.favorites.includes(id)) {
					method = 'POST';
					url = API_USER_FAVORITES;
					data = { postId: id };
				}
				try {
					await $.ajax({
						method,
						url: url.replace(':id', id),
						data,
					});
					this.toggleFavorite(id);
					item.classList.toggle('is-saved');
				} catch (error) {
					// Don't toggle the bookmark
				}
			});
		});
	}

	static toggleFavorite(id) {
		if (this.favorites.includes(id)) {
			this.favorites = this.favorites.filter(item => item !== id);
		} else {
			this.favorites.push(id);
		}
	}
}
